import jQuery from 'jquery';

jQuery(function($) {
  let $associatedText = $('.associated-text');

  $associatedText.each(function() {
    let $swiper = $('.swiper--associated-text');
    let $associatedTextItem = $associatedText.find('.associated-text__item');

    $swiper.on('slideChange', function(event, index) {
      let $activeSlide = $swiper.find('.swiper-slide[data-swiper-slide-index=' + index + ']');
      let currentAssociatedTextSelector = $activeSlide.data('associatedTextSelector');
      let $associatedTextItemCurrent = $associatedTextItem.filter(currentAssociatedTextSelector);

      $associatedTextItem.addClass('d-none');
      $associatedTextItemCurrent.removeClass('d-none');
    });
  });
});
